import type { EmailOtpType } from '@supabase/supabase-js';

const EMAIL_OTP_TYPES: readonly EmailOtpType[] = [
  'magiclink',
  'signup',
  'invite',
  'recovery',
  'email_change',
  'email',
];

/**
 * The token type to hand `verifyOtp`, taken from the link's own `type`
 * parameter rather than assumed.
 *
 * `generateLink({ type: 'magiclink' })` for an address with no auth user mints
 * a *signup* token, so a hard-coded 'magiclink' makes GoTrue reject a link that
 * was never used. The minting functions now write the type GoTrue returned; an
 * older link carries no type and is a magiclink.
 */
export function otpTypeFromLink(raw: string | null | undefined): EmailOtpType {
  return EMAIL_OTP_TYPES.includes(raw as EmailOtpType) ? (raw as EmailOtpType) : 'magiclink';
}
